import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/images/hypehive-logo.png'


const _hoisted_1 = { class: "index-page" }
const _hoisted_2 = { class: "hero__overlay d-flex flex-column align-center justify-center text-center px-6" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex ga-3 flex-wrap justify-center"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex flex-column align-center ga-3"
}
const _hoisted_5 = { class: "d-flex ga-3 flex-wrap justify-center" }
const _hoisted_6 = { class: "d-flex align-center mb-2" }
const _hoisted_7 = { class: "d-flex align-center mb-2" }
const _hoisted_8 = { class: "d-flex align-center mb-2" }

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'indexPage',
  setup(__props) {

const store = useStore();
const router = useRouter();

// 이미지 경로를 올바른 방식으로 설정
const heroImage = ref(new URL('../assets/images/장기요양지원센터 메인.jpg', import.meta.url).href);
const logo = ref(new URL('../assets/images/hypehive-logo.png', import.meta.url).href);
const jobImage = ref(new URL('../assets/images/job.jpg', import.meta.url).href);
const cityImage = ref(new URL('../assets/images/main_city2.png', import.meta.url).href);
const tableImage = ref(new URL('../assets/images/table.png', import.meta.url).href);

// 새창 참조를 저장할 변수
let loginWindow: Window | null = null;

// 로그인 상태와 사용자 정보
const isLoggedIn = computed(() => store.getters.isLoggedIn);
const currentUser = computed(() => store.getters.currentUser);
const isAdmin = computed(() => store.getters.isAdmin);

// 로그인 페이지를 새창으로 열기
const openLoginPage = () => {
  // 이미 열린 창이 있고 닫히지 않았으면 포커스
  if (loginWindow && !loginWindow.closed) {
    loginWindow.focus();
    return;
  }
  
  // 새창 열기 (화면 최대 크기)
  const screenWidth = window.screen.availWidth;
  const screenHeight = window.screen.availHeight;
  loginWindow = window.open('/pgm/login', '_blank', `width=${screenWidth},height=${screenHeight},scrollbars=yes,resizable=yes`);
  
  // 창이 닫힐 때 참조 초기화
  if (loginWindow) {
    loginWindow.addEventListener('beforeunload', () => {
      loginWindow = null;
    });
  }
};

// 대시보드로 이동 (새창으로)
const goToDashboard = () => {
  // 이미 열린 창이 있고 닫히지 않았으면 포커스
  if (loginWindow && !loginWindow.closed) {
    loginWindow.focus();
    return;
  }
  
  // 사용자 역할에 따라 경로 결정 (admin이면 관리자 페이지, user면 센터 페이지)
  const targetPath = isAdmin.value ? '/admin/members' : '/pgm/wage/WageProcess';
  
  // 새창으로 대시보드 열기
  loginWindow = window.open(targetPath, '_blank', 'width=1600,height=800,scrollbars=yes,resizable=yes');
  
  // 창이 닫힐 때 참조 초기화
  if (loginWindow) {
    loginWindow.addEventListener('beforeunload', () => {
      loginWindow = null;
    });
  }
};

// 로그아웃 처리
const handleLogout = async () => {
  try {
    await store.dispatch('performLogout');
    // 로그아웃 후 페이지 새로고침하여 상태 업데이트
    window.location.reload();
  } catch (error) {
    console.error('로그아웃 오류:', error);
  }
};

// 컴포넌트 마운트 시 인증 상태 확인
onMounted(async () => {
  await store.dispatch('validateAuth');
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_img, {
      src: tableImage.value,
      cover: "",
      height: "520",
      class: "hero"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("img", {
            src: _imports_0,
            height: "60",
            class: "mb-3",
            style: {"filter":"brightness(0) invert(1)"}
          }, null, -1)),
          _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "text-h4 text-sm-h3 text-md-h2 font-weight-bold mb-3" }, "재가장기요양센터 업무, 더 단순하게", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-body-1 text-sm-h6 mb-10" }, " 재무회계 · 임금관리 · 공단시스템 연동을 AI로 자동화해 센터장님의 시간을 아껴드립니다. ", -1)),
          (!isLoggedIn.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  size: "large",
                  onClick: openLoginPage,
                  rounded: "lg"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("지금 시작하기", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  variant: "tonal",
                  size: "large",
                  to: "/contact",
                  rounded: "lg"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("데모 문의", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-h6 text-white font-weight-medium mb-2" }, " 환영합니다! ", -1)),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    size: "large",
                    onClick: goToDashboard,
                    rounded: "lg"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("서비스 시작하기!", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    variant: "tonal",
                    color: "white",
                    size: "large",
                    onClick: handleLogout,
                    rounded: "lg"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("로그아웃", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]))
        ])
      ]),
      _: 1
    }, 8, ["src"]),
    _createVNode(_component_v_container, { class: "py-12" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "mb-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "text-center"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createElementVNode("h2", { class: "text-h5 text-md-h4 font-weight-bold mb-2" }, "센터 운영을 위한 핵심 기능", -1),
                _createElementVNode("p", { class: "text-body-2 text-medium-emphasis" }, "복잡한 인증 절차 없이, 클릭 몇 번으로 끝.", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  variant: "outlined",
                  class: "feature-card h-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: cityImage.value,
                      height: "160",
                      cover: "",
                      class: "rounded-t"
                    }, null, 8, ["src"]),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_v_icon, {
                            color: "primary",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createTextVNode("mdi-cash-multiple", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-medium" }, "재무회계 자동화", -1))
                        ]),
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-body-2 text-medium-emphasis" }, " 수입/지출 관리, 결의서 정리, 월마감까지 자동으로 정리합니다. ", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  variant: "outlined",
                  class: "feature-card h-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: jobImage.value,
                      height: "160",
                      cover: "",
                      class: "rounded-t"
                    }, null, 8, ["src"]),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_v_icon, {
                            color: "primary",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                              _createTextVNode("mdi-clipboard-check-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-medium" }, "임금관리 간소화", -1))
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-body-2 text-medium-emphasis" }, " 근무표·수당·공제 계산을 규정에 맞춰 자동 산출합니다. ", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  variant: "outlined",
                  class: "feature-card h-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: heroImage.value,
                      height: "160",
                      cover: "",
                      class: "rounded-t"
                    }, null, 8, ["src"]),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_v_icon, {
                            color: "primary",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                              _createTextVNode("mdi-domain", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-medium" }, "공단시스템 연동", -1))
                        ]),
                        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-body-2 text-medium-emphasis" }, " 공단 양식과 데이터 연동으로 입력·제출 과정을 단순화합니다. ", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, { class: "py-10 py-md-14" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_sheet, {
          class: "cta rounded-lg px-6 py-10 text-center mx-auto",
          elevation: "0",
          "max-width": "1080"
        }, {
          default: _withCtx(() => [
            _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "text-h6 text-md-h5 font-weight-bold mb-2" }, "업무는 단순하게, 케어는 더 깊게", -1)),
            _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-body-2 text-medium-emphasis mb-6" }, "오늘부터 반복 작업을 줄이고, 중요한 일에 집중해보세요.", -1)),
            (!isLoggedIn.value)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  color: "primary",
                  size: "large",
                  rounded: "lg",
                  onClick: openLoginPage
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode(" 무료로 시작하기 ", -1)
                  ]))]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  color: "primary",
                  size: "large",
                  rounded: "lg",
                  onClick: goToDashboard
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode(" 서비스 시작하기! ", -1)
                  ]))]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})